var map = {
	"./advertorial.svg": 175,
	"./album.svg": 176,
	"./analysis.svg": 177,
	"./anchor.svg": 178,
	"./android-block.svg": 179,
	"./android-small.svg": 180,
	"./android.svg": 181,
	"./angle-down.svg": 182,
	"./angle-left.svg": 183,
	"./angle-right.svg": 184,
	"./angle-up.svg": 185,
	"./aquarius.svg": 186,
	"./aries.svg": 187,
	"./arrow-left.svg": 188,
	"./arrow-right.svg": 189,
	"./arrow.svg": 190,
	"./art-director.svg": 191,
	"./author.svg": 192,
	"./authoranchor.svg": 193,
	"./automobile.svg": 194,
	"./brandconnect.svg": 195,
	"./breaking-news.svg": 196,
	"./bullet-arrow.svg": 197,
	"./bundle.svg": 198,
	"./business.svg": 199,
	"./cancel.svg": 200,
	"./cancer.svg": 201,
	"./canvas.svg": 202,
	"./capricorn.svg": 203,
	"./cartoonist.svg": 204,
	"./cinema.svg": 205,
	"./clapboard.svg": 206,
	"./clipboard.svg": 207,
	"./close.svg": 208,
	"./comm-album.svg": 209,
	"./comm-automobile.svg": 210,
	"./comm-children.svg": 211,
	"./comm-cinema.svg": 212,
	"./comm-entertainment.svg": 213,
	"./comm-environment.svg": 214,
	"./comm-finance.svg": 215,
	"./comm-gadgets.svg": 216,
	"./comm-health.svg": 217,
	"./comm-lifestyle.svg": 218,
	"./comm-news.svg": 219,
	"./comm-science.svg": 220,
	"./comm-spiritual.svg": 221,
	"./comm-sports.svg": 222,
	"./comm-technology.svg": 223,
	"./comm-video.svg": 224,
	"./comm-vikatan-plus.svg": 225,
	"./comm-women.svg": 226,
	"./comm-world-cup.svg": 227,
	"./comment.svg": 228,
	"./creative-director.svg": 229,
	"./data.svg": 230,
	"./designed.svg": 231,
	"./download.svg": 232,
	"./edited-by.svg": 233,
	"./email.svg": 234,
	"./environment.svg": 235,
	"./exclusivedeals.svg": 236,
	"./facebook-bg.svg": 237,
	"./facebook.svg": 238,
	"./filter-icon.svg": 239,
	"./filter.svg": 240,
	"./food-stylist.svg": 241,
	"./gallery.svg": 242,
	"./gemini.svg": 243,
	"./group.svg": 244,
	"./health.svg": 245,
	"./hexbackground.svg": 246,
	"./illustrator-t1.svg": 247,
	"./illustrator.svg": 248,
	"./infographer.svg": 249,
	"./instagram.svg": 250,
	"./interviews.svg": 251,
	"./ios-block.svg": 252,
	"./ios-small.svg": 253,
	"./ios.svg": 254,
	"./jokes.svg": 255,
	"./leo.svg": 256,
	"./libra.svg": 257,
	"./lifestyle.svg": 258,
	"./line-arrow-next.svg": 259,
	"./line-arrow-prev.svg": 260,
	"./linkedin.svg": 261,
	"./magazines.svg": 262,
	"./minus.svg": 263,
	"./mobile-share.svg": 264,
	"./moderated.svg": 265,
	"./narrated.svg": 266,
	"./news.svg": 267,
	"./newsletter.svg": 268,
	"./newslettericon.svg": 269,
	"./pen.svg": 270,
	"./photo.svg": 271,
	"./photographer.svg": 272,
	"./photostory.svg": 273,
	"./pisces.svg": 274,
	"./plus.svg": 275,
	"./poems.svg": 276,
	"./premium.svg": 277,
	"./producer.svg": 278,
	"./proofread.svg": 279,
	"./published-by.svg": 280,
	"./published.svg": 281,
	"./rss.svg": 282,
	"./sagitarius.svg": 283,
	"./scorpio.svg": 284,
	"./script-writer.svg": 285,
	"./scripted.svg": 286,
	"./search.svg": 287,
	"./share-alt.svg": 288,
	"./share.svg": 289,
	"./shortstories.svg": 290,
	"./slider-next.svg": 291,
	"./slider-prev.svg": 292,
	"./socialshare.svg": 293,
	"./sort.svg": 294,
	"./sound.svg": 295,
	"./speaker.svg": 296,
	"./spiritual.svg": 297,
	"./sponsored.svg": 298,
	"./sports.svg": 299,
	"./stylist.svg": 300,
	"./taurus.svg": 301,
	"./technology.svg": 302,
	"./trending.svg": 303,
	"./twitter.svg": 304,
	"./user.svg": 305,
	"./video-editor.svg": 306,
	"./video.svg": 307,
	"./videographer.svg": 308,
	"./vikatan-tv.svg": 309,
	"./vikatanconnect.svg": 310,
	"./vikatantv.svg": 311,
	"./virgo.svg": 312,
	"./whatsapp.svg": 313,
	"./writtenarticles.svg": 314,
	"./writtenstory.svg": 315,
	"./youtube.svg": 316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;